// AUTO-GENERATED by scripts/data/build-comuni-stats.js — do not edit by hand.
// Counts ONLY administrative comuni (entries without kind: "localita") so that
// no counter on the site is inflated by frazioni/località pages.
// Kept separate from comuni-toscana.js to keep the dataset out of the LCP bundle.

export const COMUNI_COUNT_BY_PROVINCE = Object.freeze({
  firenze: 41,
  pisa: 37,
  lucca: 33,
  pistoia: 20,
  prato: 7,
  livorno: 19,
  grosseto: 28,
  siena: 35,
  arezzo: 36,
  "massa-carrara": 17,
  genova: 41,
  savona: 33,
  imperia: 35,
  "la-spezia": 30,
  perugia: 56,
  terni: 31,
  viterbo: 41,
  rieti: 48,
});

export const COMUNI_TOTAL = 588;
export const LOCALITA_TOTAL = 9;

/** Total administrative comuni across an array of province slugs. */
export function countComuniInProvinces(provSlugs) {
  let total = 0;
  for (const slug of provSlugs) total += COMUNI_COUNT_BY_PROVINCE[slug] || 0;
  return total;
}
